module.exports = __webpack_public_path__ + "static/media/calling.51bf0c5f.mp3";